/**
 * Decorators
 * */
export const TAGS_DECORATOR = 'tags'
export const LEXIQA_DECORATOR = 'lexiqa'
export const GLOSSARY_DECORATOR = 'glossary'
export const QA_GLOSSARY_DECORATOR = 'qaCheckGlossary'
export const QA_BLACKLIST_DECORATOR = 'qaCheckBlacklist'
export const SEARCH_DECORATOR = 'search'
export const SPLIT_DECORATOR = 'split'
export const ICU_DECORATOR = 'icu'
